import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, useWindowDimensions } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useNavigate } from 'react-router-dom';

const MOBILE_MAX_WIDTH = 768;

interface UserAppMobileGateProps {
  children: React.ReactNode;
}

/**
 * Vista usuario (comensales): solo layout estrecho / viewport móvil.
 * En escritorio muestra aviso y enlace a la web pública.
 */
export function UserAppMobileGate({ children }: UserAppMobileGateProps) {
  const { width } = useWindowDimensions();
  const insets = useSafeAreaInsets();
  const navigate = useNavigate();
  const [ready, setReady] = useState(typeof window === 'undefined');

  useEffect(() => {
    if (typeof window !== 'undefined') setReady(true);
  }, []);

  if (!ready) {
    return null;
  }

  const isMobile = width < MOBILE_MAX_WIDTH;

  if (!isMobile) {
    return (
      <View style={styles.desktopBlock}>
        <Text style={styles.desktopTitle}>Vista solo en móvil</Text>
        <Text style={styles.desktopText}>
          El área para comensales está pensada para teléfono. Abre esta misma dirección desde tu móvil o prueba a reducir la ventana del navegador.
        </Text>
        <TouchableOpacity style={styles.desktopButton} onPress={() => navigate('/')} activeOpacity={0.85}>
          <Text style={styles.desktopButtonText}>Ir a la web pública</Text>
        </TouchableOpacity>
      </View>
    );
  }

  return (
    <View style={[styles.mobileShell, { paddingTop: insets.top }]}>{children}</View>
  );
}

const styles = StyleSheet.create({
  mobileShell: {
    flex: 1,
    backgroundColor: '#ffffff',
    maxWidth: 480,
    width: '100%',
    alignSelf: 'center',
  },
  desktopBlock: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 32,
    backgroundColor: '#fafafa',
  },
  desktopTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#030213',
    marginBottom: 12,
    textAlign: 'center',
  },
  desktopText: {
    fontSize: 15,
    color: '#4b5563',
    textAlign: 'center',
    lineHeight: 22,
    marginBottom: 24,
    maxWidth: 400,
  },
  desktopButton: {
    backgroundColor: '#030213',
    paddingVertical: 14,
    paddingHorizontal: 24,
    borderRadius: 8,
  },
  desktopButtonText: {
    color: '#ffffff',
    fontSize: 15,
    fontWeight: '600',
  },
});
